export const defaultCustomStyles = (baseStyles: string) => baseStyles;

export const ADD_AUTO_HEIGHT_COMPONENTS = ["container", "control", "valueContainer"];

export const DROPDOWN_ID = "dropdown-menu-id";
export const DROPDOWN_MENU_ID = "dropdown-menu-list-id";
export const DROPDOWN_MENU_ARIA_LABEL = "Dropdown menu";
export const DROPDOWN_INPUT_ARIA_LABEL = "Dropdown input";

export const DROPDOWN_CHIP_COLORS = {
  PRIMARY: "PRIMARY",
  NEGATIVE: "NEGATIVE",
  POSITIVE: "POSITIVE"
};

export const DROPDOWN_MENU_POSITION = {
  ABSOLUTE: "absolute",
  FIXED: "fixed"
};

export const DROPDOWN_MENU_PLACEMENT = {
  TOP: "top",
  BOTTOM: "bottom",
  AUTO: "auto"
};
